/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type LocalReplyListContainer_story = {
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_story">;
    readonly " $refType": "LocalReplyListContainer_story";
};
export type LocalReplyListContainer_story$data = LocalReplyListContainer_story;
export type LocalReplyListContainer_story$key = {
    readonly " $data"?: LocalReplyListContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"LocalReplyListContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LocalReplyListContainer_story",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListCommentContainer_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = 'd5a96e82e3c8fd0bdc44a36f6183b476';
export default node;
